export const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(" ");
  return parts.length === 1
    ? parts[0][0].toUpperCase()
    : (parts[0][0] + parts[1][0]).toUpperCase();
};

export const getAvatarColor = (name) => {
  const colors = ["#007bff", "#28a745", "#17a2b8", "#ffc107", "#6f42c1"];
  const index = name ? name.length % colors.length : 0;
  return colors[index];
};
